import { avatarVariants } from './avatar-variants';
import { breakpoints, mediaQueries } from './breakpoints';
import { input } from './input';
import { colors } from './colors';
import * as typography from './typography';
import { textVariants } from './text-variants';
import { space } from './space';
import { button } from './button';
import { card } from './card';
import { borderRadiuses } from './border-radiuses';
import { switchVariants } from './switch-variants';
import { pillControl } from './pill-control';
import { alertVariants } from './alert-variants';
import { badgeVariants } from './badge-variants';
import { spinnerVariants } from './spinner-variants';
import { zIndices } from './zIndices';
import { toastVariants } from './toast-variants';
export const theme = {
    avatarVariants,
    badgeVariants,
    breakpoints,
    mediaQueries,
    colors,
    space,
    button,
    radii: borderRadiuses,
    input,
    textVariants,
    switchVariants,
    ...typography,
    pillControl,
    alertVariants,
    spinnerVariants,
    zIndices,
    card,
    toastVariants,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ25ELE9BQU8sRUFBRSxXQUFXLEVBQUUsWUFBWSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQzFELE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFDaEMsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUNsQyxPQUFPLEtBQUssVUFBVSxNQUFNLGNBQWMsQ0FBQztBQUMzQyxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFDL0MsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUNoQyxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQ2xDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxRQUFRLENBQUM7QUFDOUIsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ25ELE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUNuRCxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUFDN0MsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBQ2pELE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQztBQUNqRCxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sb0JBQW9CLENBQUM7QUFDckQsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLFlBQVksQ0FBQztBQUN0QyxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFFakQsTUFBTSxDQUFDLE1BQU0sS0FBSyxHQUFVO0lBQzFCLGNBQWM7SUFDZCxhQUFhO0lBQ2IsV0FBVztJQUNYLFlBQVk7SUFDWixNQUFNO0lBQ04sS0FBSztJQUNMLE1BQU07SUFDTixLQUFLLEVBQUUsY0FBYztJQUNyQixLQUFLO0lBQ0wsWUFBWTtJQUNaLGNBQWM7SUFDZCxHQUFHLFVBQVU7SUFDYixXQUFXO0lBQ1gsYUFBYTtJQUNiLGVBQWU7SUFDZixRQUFRO0lBQ1IsSUFBSTtJQUNKLGFBQWE7Q0FDZCxDQUFDIn0=